import React, { useState, useEffect } from 'react';
import axios from 'axios';

import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import FlightTakeoffIcon from '@material-ui/icons/FlightTakeoff';
import FlightLandIcon from '@material-ui/icons/FlightLand';
import EventOutlinedIcon from '@material-ui/icons/EventOutlined';
import Fab from '@material-ui/core/Fab';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import AccessibilityOutlinedIcon from '@material-ui/icons/AccessibilityOutlined';
import ChildCareOutlinedIcon from '@material-ui/icons/ChildCareOutlined';
import ChildFriendlyOutlinedIcon from '@material-ui/icons/ChildFriendlyOutlined';
import AirplanemodeActiveOutlinedIcon from '@material-ui/icons/AirplanemodeActiveOutlined';
import ViewHeadlineOutlinedIcon from '@material-ui/icons/ViewHeadlineOutlined';
import Alert from '@material-ui/lab/Alert';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import CustomSelect from '../custom-select';
import { checkTokenExpirationMiddleware } from '../../../../middlewares/users-auth.middleware';
import { createUploadState, uploadSelectedFile } from '../../../../helpers/attachment-helper';
import * as FlightTypes from '../../../../magic-strings/flight-type';

const FlightOfferForm = ({ handleReloadOffers, reservationReqId }) => {
    const [flightCabin, setFlightCabin] = useState([]);
    const [flightType, setFlightType] = useState([]);
    const [destination, setDestination] = useState([]);
    const [airline, setAirline] = useState([]);
    const [chosenFlightType, setChosenFlightType] = useState(null);
    const [error, setError] = useState(null);
    const [user] = useState(checkTokenExpirationMiddleware());
    const [addRow, setAddRow] = useState([]);
    const [loader, setLoader] = useState(false);
    const [success, setSuccess] = useState(null);
    const [serverError, setServerError] = useState(null);
    const [attachmentUpload, setAttachmentUpload] = useState(createUploadState());

    const appendRow = () => {
        let rows = [...addRow];
        rows.push(1);
        setAddRow(rows);
    };

    const directOrIndeirect = [
        { "key": 1, "value": "Direct" },
        { "key": 2, "value": "Indirect" }
    ];
    let headers = {
        "Authorization": `Bearer ${user.Token}`
    };
    useEffect(() => {
        axios.get("/api/flightcabin", { headers: headers })
            .then(res => { setFlightCabin(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/flighttype", { headers: headers })
            .then(res => { setFlightType(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/destination", { headers: headers })
            .then(res => { setDestination(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
        axios.get("/api/airline", { headers: headers })
            .then(res => { setAirline(res.data); })
            .catch(err => { setError({ error: "Error Loading page" }); });
    }, [user]);

    const handleAttachmentChange = async (event) => {
        await uploadSelectedFile({
            file: event.target.files.length > 0 ? event.target.files[0] : null,
            category: "flight",
            token: user.Token,
            setUploadState: setAttachmentUpload
        });
    };

    const submitOffer = (event) => {
        event.preventDefault();
        setLoader(true);
        setError(null);
        let flightType = event.target.querySelector("#fl-ty input").value;
        let flightRows = event.target.querySelectorAll(".fl-rw");
        let noPriceInputs = event.target.querySelectorAll("#no-pr input");
        let flightTextarea = event.target.querySelectorAll('textarea');
        let attachFile = event.target.querySelector("#file-attach");

        if (attachmentUpload.uploading) {
            setError("Attachment upload is still in progress.");
            setLoader(false);
            return;
        }

        if (attachFile.files.length > 0 && !attachmentUpload.blobPath) {
            setError(attachmentUpload.error || "Upload the attachment before submitting the offer.");
            setLoader(false);
            return;
        }

        let flightOfferDetailResources = [];
        let flightOfferResource = new FormData();
        flightOfferResource.append("ReservationReqId", reservationReqId);
        flightOfferResource.append("OfferHeadline", event.target.querySelector("#hd-ln").value);
        flightOfferResource.append("FlightTypeId", parseInt(flightType));
        flightOfferResource.append("AdultsNumber", parseInt(noPriceInputs[0].value));
        flightOfferResource.append("AdultPrice", parseFloat(noPriceInputs[1].value));
        if (noPriceInputs[2].value !== "")
            flightOfferResource.append("ChildrenNumber", parseInt(noPriceInputs[2].value));
        if (noPriceInputs[2].value !== "" && noPriceInputs[3].value !== "")
            flightOfferResource.append("ChildPrice", parseFloat(noPriceInputs[3].value));
        if (noPriceInputs[4].value !== "")
            flightOfferResource.append("InfantsNumber", parseInt(noPriceInputs[4].value));
        if (noPriceInputs[4].value !== "" && noPriceInputs[5].value !== "")
            flightOfferResource.append("InfantPrice", parseFloat(noPriceInputs[5].value));
        flightOfferResource.append("PaymentPolicy", flightTextarea[0].value);
        flightOfferResource.append("IssuanceTimeLimit", flightTextarea[1].value);
        flightOfferResource.append("CancellationPolicy", flightTextarea[2].value);
        flightOfferResource.append("ChangesPolicy", flightTextarea[3].value);
        flightOfferResource.append("AttachmentFile", attachmentUpload.blobPath ? attachmentUpload.blobPath : "");

        for (let i = 0; i < flightRows.length; i++) {
            let rowInputs = flightRows[i].querySelectorAll("input");
            let offerDetail = {
                FromCityId: parseInt(rowInputs[0].value),
                ToCityId: parseInt(rowInputs[1].value),
                AirlineId: parseInt(flightType) !== FlightTypes.RoundTrip ? parseInt(rowInputs[3].value) : parseInt(rowInputs[4].value),
                FlightCabinTypeId: parseInt(flightType) !== FlightTypes.RoundTrip ? parseInt(rowInputs[4].value) : parseInt(rowInputs[5].value),
                IsDirectFlight: parseInt(flightType) !== FlightTypes.RoundTrip ? rowInputs[5].value === "1" : rowInputs[6].value === "1",
                DepartureDate: rowInputs[2].value,
                ReturnDate: parseInt(flightType) === FlightTypes.RoundTrip ? rowInputs[3].value : null
            };
            flightOfferDetailResources.push(offerDetail);
        }
        flightOfferResource.append("ReservationSupplierFlightOfferDetailResourcesJson", JSON.stringify(flightOfferDetailResources));

        let headers = {
            "Accept": "application/json",
            "Authorization": `Bearer ${user.Token}`,
            "Content-Type": "multipart/form-data",
            "Content-Encoding": "gzip"
        };
        axios.post(`/api/flightoffer`, flightOfferResource, { headers: headers })
            .then(res => {
                setSuccess(true);
                setTimeout(() => {
                    setLoader(false);
                    handleReloadOffers();
                    setChosenFlightType(null);
                }, 750);
            })
            .catch(err => {
                let errorMsg = "Error Adding Offer — Try again later!";
                if (err.response && err.response.data) {
                    const data = err.response.data;
                    if (data.errors) {
                        errorMsg = Object.values(data.errors).flat().join(" | ");
                    } else if (typeof data === "string") {
                        errorMsg = data;
                    }
                }
                setServerError(errorMsg);
                setSuccess(false);
                setTimeout(() => setLoader(false), 750);
            });
    }

    return (
        <>
            <Backdrop className="backdrop" open={loader}>
                <CircularProgress color="inherit" />
            </Backdrop>
            <form onSubmit={submitOffer}>
                <Grid
                    container
                    spacing={1}
                >
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <TextField
                                id="hd-ln"
                                label={"Offer Headline"}
                                helperText={"Write an uniqe/request offer headline. Recommended to contain your company name and the word 'hotel'(ex: Flight Offer 1, Exclusive Flight offer)"}
                                fullWidth
                                type={"text"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ViewHeadlineOutlinedIcon fontSize={"small"} />
                                        </InputAdornment>
                                    )
                                }}
                                required
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            <FormControl
                                id="fl-ty"
                                margin="dense"
                                placeholder="Flight Type"
                                fullWidth
                                required
                            >
                                <InputLabel>Flight Type</InputLabel>
                                <Select
                                    label="Flight Type"
                                    value={chosenFlightType === null ? '' : chosenFlightType}
                                    onChange={(event) => {
                                        setAddRow([]);
                                        setChosenFlightType(event.target.value);
                                    }}
                                >
                                    {
                                        flightType ?
                                            flightType.map((item, index) =>
                                                <MenuItem key={index} value={item.key}>{item.value}</MenuItem>
                                            )
                                            : null
                                    }
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                    {
                        chosenFlightType ?
                            chosenFlightType === FlightTypes.RoundTrip ?
                                <FlightRow
                                    returnTrip={true}
                                    destination={destination}
                                    airline={airline}
                                    flightCabin={flightCabin}
                                    directOrIndeirect={directOrIndeirect}
                                />
                                :
                                <FlightRow
                                    returnTrip={false}
                                    destination={destination}
                                    flightCabin={flightCabin}
                                    airline={airline}
                                    directOrIndeirect={directOrIndeirect}
                                />
                            : null
                    }
                    {
                        chosenFlightType ?
                            chosenFlightType === FlightTypes.MultiDestination ?
                                <>
                                    {
                                        addRow.map((item, index) =>
                                            <FlightRow
                                                key={index}
                                                returnTrip={false}
                                                destination={destination}
                                                flightCabin={flightCabin}
                                                airline={airline}
                                                directOrIndeirect={directOrIndeirect}
                                            />
                                        )
                                    }
                                    <Grid container justify="flex-end">
                                        <Fab size="small" color="primary" aria-label="add" onClick={appendRow}>
                                            <AddIcon />
                                        </Fab>
                                    </Grid>
                                </>
                                : null
                            : null
                    }
                    <Grid id="no-pr" container item xs={12} spacing={2} style={{ marginTop: `35px` }}>
                        <Grid item sm={6} md={6} lg={2}>
                            <TextField
                                label={"Adults No."}
                                fullWidth
                                type={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <AccessibilityOutlinedIcon fontSize={"small"} />
                                        </InputAdornment>
                                    ),
                                    inputProps: { min: 1 }
                                }}
                                required
                            />
                        </Grid>
                        <Grid item sm={6} md={6} lg={2}>
                            <TextField
                                label={"Price/Adult"}
                                fullWidth
                                type={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LocalAtmIcon fontSize={"small"} />
                                        </InputAdornment>
                                    ),
                                    inputProps: { min: 0 }
                                }}
                                required
                            />
                        </Grid>
                        <Grid item sm={6} md={6} lg={2}>
                            <TextField
                                label={"Childs No."}
                                fullWidth
                                type={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ChildCareOutlinedIcon fontSize={"small"} />
                                        </InputAdornment>
                                    ),
                                    inputProps: { min: 0 }
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} md={6} lg={2}>
                            <TextField
                                label={"Price/Child"}
                                fullWidth
                                type={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LocalAtmIcon fontSize={"small"} />
                                        </InputAdornment>
                                    ),
                                    inputProps: { min: 0 }
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} md={6} lg={2}>
                            <TextField
                                label={"Infant No."}
                                fullWidth
                                type={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <ChildFriendlyOutlinedIcon fontSize={"small"} />
                                        </InputAdornment>
                                    ),
                                    inputProps: { min: 0 }
                                }}
                            />
                        </Grid>
                        <Grid item sm={6} md={6} lg={2}>
                            <TextField
                                label={"Price/Infant"}
                                fullWidth
                                type={"number"}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <LocalAtmIcon fontSize={"small"} />
                                        </InputAdornment>
                                    ),
                                    inputProps: { min: 0 }
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextField
                                label="Payment Policy"
                                multiline
                                fullWidth
                                required
                                rows={3}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextField
                                label="Time limit for issuance"
                                multiline
                                fullWidth
                                required
                                rows={3}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextField
                                label="Cancellation Policy"
                                multiline
                                fullWidth
                                required
                                rows={3}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={12} md={6} lg={4}>
                            <TextField
                                label="Changes Policy"
                                multiline
                                fullWidth
                                required
                                rows={3}
                                variant="outlined"
                            />
                        </Grid>
                        <Grid item sm={6} md={4} lg={2}>
                            <input
                                accept=".jpg,.jpeg,.png,.bmp,.gif,.pdf,.doc,.docx,.xls,.pptx,.xlsx"
                                style={{ display: `none` }}
                                id={`file-attach`}
                                type="file"
                                onChange={handleAttachmentChange}
                            />
                            <label htmlFor={`file-attach`}>
                                <Button variant="outlined" color="primary" component="span">
                                    Attachment
                                </Button>
                            </label>
                            {
                                attachmentUpload.uploading ?
                                    <div style={{ marginTop: "8px" }}>Uploading attachment...</div>
                                    : null
                            }
                            {
                                attachmentUpload.originalFileName ?
                                    <div style={{ marginTop: "8px" }}>{attachmentUpload.originalFileName}</div>
                                    : null
                            }
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            {
                                typeof error === "string" ?
                                    <Alert variant="filled" severity="error">{error}</Alert>
                                    : null
                            }
                            {
                                success === false ?
                                    <Alert variant="filled" severity="error">{serverError || "Error Adding Offer — Try again later!"}</Alert>
                                    : null
                            }
                            {
                                success === true ?
                                    <Alert variant="filled" severity="success">Offer Added Successfully</Alert>
                                    : null
                            }
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} spacing={2}>
                        <Grid item xs={12} sm={6}>
                            {
                                chosenFlightType ?
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                    >
                                        Submit Offer
                                        </Button>
                                    : null
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </form>
        </>
    )
}

const FlightRow = ({ returnTrip, destination, airline, flightCabin, directOrIndeirect }) => {
    const [_destination] = useState(destination);
    const [_flightCabin] = useState(flightCabin);
    const [_airline] = useState(airline);
    const [_directOrIndeirect] = useState(directOrIndeirect);
    return (
        <Grid container item xs={12} spacing={2} className="fl-rw">
            <Grid item sm={4} md={4} lg={2}>
                <CustomSelect
                    data={_destination}
                    label={"From"}
                    required={true}
                    icon={<FlightTakeoffIcon fontSize={"small"} />}
                />
            </Grid>
            <Grid item sm={4} md={4} lg={2}>
                <CustomSelect
                    data={_destination}
                    label={"To"}
                    required={true}
                    icon={<FlightLandIcon fontSize={"small"} />}
                />
            </Grid>
            <Grid item sm={4} md={4} lg={2}>
                <TextField
                    label={"Departure"}
                    fullWidth
                    type={"date"}
                    InputProps={{
                        startAdornment: (
                            <InputAdornment position="start">
                                <EventOutlinedIcon fontSize={"small"} />
                            </InputAdornment>
                        )
                    }}
                    required
                />
            </Grid>
            {
                returnTrip ?
                    <Grid item sm={4} md={4} lg={2}>
                        <TextField
                            label={"Return"}
                            fullWidth
                            type={"date"}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <EventOutlinedIcon fontSize={"small"} />
                                    </InputAdornment>
                                )
                            }}
                            required
                        />
                    </Grid>
                    : null
            }
            <Grid item sm={4} md={4} lg={2}>
                <CustomSelect
                    data={_airline}
                    label={"Airline"}
                    required={true}
                    icon={<AirplanemodeActiveOutlinedIcon fontSize={"small"} />}
                />
            </Grid>
            <Grid item sm={4} md={4} lg={2}>
                <CustomSelect
                    data={_flightCabin}
                    label={"Cabin Type"}
                    required={true}
                />
            </Grid>
            <Grid item sm={4} md={4} lg={2}>
                <CustomSelect
                    data={_directOrIndeirect}
                    label={"Direct/Indirect"}
                    required={true}
                />
            </Grid>
        </Grid>
    )
};

export default FlightOfferForm;
